<template>
  <div class="search-block">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem
          v-if="searchType === 'collect' && theUserIdentity === 'edu'"
          label=""
        >
          <RemoteSelect
            v-model="schoolId"
            placeholder="请选择学校"
            :remote-method="getSchoolList"
            :loading="loadingSchool"
            @clear="getSchoolList('')"
            @visible-change="loadAllList"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.orgId"
              :label="item.schoolName"
              :value="item.orgId"
            >
            </el-option>
          </RemoteSelect>
        </FormItem>
        <FormItem v-if=" theUserIdentity !== 'org'" prop="orgId" label="">
          <choose-apply
            ref="chooseApplyRef"
            org-type=""
            :cache-org-id="listParams.orgId"
            :cache-org-name="listParams.orgName"
            @on-change="handleOnApplyChange"
          ></choose-apply>
        </FormItem>
        <FormItem v-else prop="orgId" label="">
          {{ userInfo.orgName }}
        </FormItem>
        <FormItem label="">
          <Input
            v-model="listParams.classroomName"
            clearable
            placeholder="课程班级名称"
            class="search-input-430"
          ></Input>
        </FormItem>
        <!-- <FormItem label="">
          <Input
            v-model="listParams.teacherName"
            clearable
            placeholder="教师姓名"
            class="search-input-430"
          ></Input>
        </FormItem> -->
        <FormItem label="" prop="teaId">
          <Select
            v-model="listParams.teaId"
            clearable
            filterable
            placeholder="教师姓名"
            class="search-select-430"
          >
            <Option
              v-for="(item, index) in teacherList"
              :key="index"
              :value="item.teacherId"
            >{{ item.teacherName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :placeholder="`请选择学期`"
            :clearable="false"
            @on-change="onCascaderChange"
          ></CascaderYearTerms>
        </FormItem>
        <FormItem label="">
          <DatePicker
            :value="listParams.yearMonth"
            type="month"
            placeholder="请选择月份"
            class="dateMonth-430"
            :clearable="false"
            transfer
            format="yyyy-MM"
            @on-change="onYearMonthChange"
          ></DatePicker>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="listParams.classType"
            clearable
            placeholder="请选择课程分类"
            class="search-select-430"
          >
            <Option
              v-for="(item, index) in trainingTypes"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="listParams.offerOrgType"
            clearable
            placeholder="请选择分类"
            class="search-select-430"
          >
            <Option
              v-for="(item, index) in offerOrgTypeList"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <Button
          type="primary"
          :disabled="!schoolId"
          @click="handleSearch"
        >查询</Button>
        <Button
          class="search-430"
          :disabled="!schoolId"
          @click="handleReset"
        >重置</Button>
      </Row>
      <Row class="relative" type="flex" justify="end"> </Row>
    </Form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import orderCenterApi from '@/request/orderCenter/index.js';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
import RemoteSelect from '@c/RemoteSelect';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import { getTodayDate } from '@/utils/moment.js';
import { getSearchsStorage, setSearchsStorage } from '@/utils/storage';
export default {
  name: 'SearchBlock',
  components: {
    ChooseApply,
    CascaderYearTerms,
    RemoteSelect
  },
  props: {
    searchType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      schoolId: '',
      termIdList: [],
      initTermId: true, // 是否刚进来页面 获取 学期
      listParams: {
        yearCode: '',
        termCode: 0,
        orgId: this.$route.query.orgId,
        classroomName: this.$route.query.classroomName,
        teacherName: this.$route.query.teacherName,
        yearMonth: this.$route.query.yearMonth ? this.$route.query.yearMonth : getTodayDate('YYYY-MM'),
        classType: this.$route.query.trainingType,
        orgName: this.$route.query.orgName,
        teaId: this.$route.query.teaId,
        offerOrgType: ''
      },
      loading3: false,
      teacherList: [],
      initYear: [],
      trainingTypes: [{
        value: '1',
        label: '素质课'
      }, {
        value: '2',
        label: '基础托管'
      }],
      offerOrgTypeList: [
        {
          value: '1',
          label: '校内课程'
        }, {
          value: '2',
          label: '校外课程'
        }
      ],

      yearTermCode: [],
      dataChange: 1,
      loadingSchool: false,
      schoolList: [],
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      searchNum: 0
    };
  },
  computed: { ...mapState(['userInfo', 'theUserIdentity', 'schoolIdForState']), ...mapGetters(['routeTitle']) },
  created() {
    this.init();
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      this.handleChangeSchool(id);
    });
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.handleChangeSchool(id);
    });
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  methods: {
    async init() {
      const info = getSearchsStorage();

      if (this.$route.name == 'eduCenter_schoolAttendance_collect' && info) {
        this.setCaChe(info);
      }
      if (this.theUserIdentity === 'school') {
        this.schoolId = this.userInfo.orgId;
        // this.handleSearch();
      } else {
        // 添加初始化学校
        // this.schoolId = localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
        this.schoolId = this.schoolIdForState ? this.schoolIdForState : '';
        // if (this.schoolId) {
        //   this.handleChangeSchool(this.schoolId);
        // }
      }
      if (this.searchType === 'collect' && this.theUserIdentity === 'edu') {
        this.schoolId = -1;
      }
      this.getTeacherlist('');
    },
    setCaChe(info) {
      this.listParams.classroomName = info.classroomName;
      this.listParams.teacherName = info.teacherName;
      this.listParams.yearMonth = info.yearMonth;
      this.listParams.classType = info.classType;
      this.listParams.orgName = info.orgName;
      this.listParams.orgId = info.orgId;
      this.listParams.teaId = info.teaId;
    },
    // 运营端切换学校
    async handleChangeSchool(id) {
      console.log('运营端切换学校--------------');
      this.schoolId = id;

      this.listParams.teaId = '';
      this.handleSearch();
      this.getTeacherlist('');
    },
    onYearMonthChange(month) {
      this.listParams.yearMonth = month;
    },
    // 重置
    async handleReset() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();

      // this.$refs.cascaderYearTermsRef && this.$refs.cascaderYearTermsRef.handleDefault();
      // console.log('重置==》', 121212);
      const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault();
      // }'

      this.listParams = {
        // termId: '',
        classroomName: '',
        teacherName: '',
        yearMonth: getTodayDate('YYYY-MM'),
        classType: '',
        orgName: '',
        offerOrgType: ''
      };
      if (yearTerms.length) {
        this.listParams.yearCode = yearTerms[0];
        this.listParams.termCode = yearTerms[1];
      }
      this.handleSearch();
    },
    async onCascaderChange(v) {
      console.log('那打了---', v);
      this.yearTermCode = v;
      localStorage.setItem('yearTermCode', this.yearTermCode);
      this.listParams.yearCode = v.length ? v[0] : '';
      this.listParams.termCode = v.length ? v[1] : '';
      if (this.searchType === 'collect' && this.theUserIdentity === 'edu') {
        this.getSchoolList();
      }
      if (this.dataChange === 1) {
        this.handleSearch();
        this.dataChange++;
      }
    },
    // 查询
    handleSearch() {
      // const yearTerms = this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.getResult();
      // this.listParams.yearCode = yearTerms.length > 0 ? yearTerms[0] : '';
      // this.listParams.termCode = yearTerms.length > 0 ? yearTerms[1] : '';
      if (!this.listParams.yearCode || !this.listParams.termCode) {
        return;
      }
      this.searchNum++;
      const sysYt = this.$refs.cascaderYearTerms.getObjResult();
      this.listParams.sysYTBeginTime = sysYt ? sysYt.beginTime : '';
      this.listParams.sysYTEndTime = sysYt ? sysYt.endTime : '';
      setSearchsStorage({ schoolId: this.schoolId, ...this.listParams });
      this.$emit('on-search', { schoolId: this.schoolId, ...this.listParams });
    },
    // 教师姓名下拉列表
    async getTeacherlist(teacherName) {
      const params = {
        schoolId: this.schoolId,
        teacherName: teacherName
      };
      const res = await this.$http.getQuerySchoolOrgTeacher(params);
      if (res.status === 200) {
        this.teacherList = res.message;
        this.loading3 = false;
      }
    },
    /** ***** 有关学校列表的操作 start  ********/
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    // 获取学校列表
    getSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = {
        orgName: query,
        yearCode: this.listParams.yearCode,
        termCode: this.listParams.termCode,
        orgType: 1
      };
      this.getSchoolListAdmin(queryTrue);
    },
    // 请求学校列表(运营端,教育局端,机构端)
    async getSchoolListAdmin(query) {
      const params = Object.assign(this.schoolPageInfo, query);
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.schoolId = item.orgId;
          item.schoolName = item.name || item.orgName;
          return item;
        });
        this.schoolList.unshift({
          schoolId: -1,
          schoolName: '全部学校',
          orgId: -1,
          name: '全部学校'
        });
        this.schoolPageInfo.total = Number(res.message.total);
        this.loadingSchool = false;
      }
    },
    /** ***** 有关请求提供方的操作 start  ********/
    // 提供方组件值改变
    handleOnApplyChange(val) {
      this.listParams.orgId = val.orgId;
      this.listParams.orgName = val.orgName;
      console.log(val, 1);
    },
    remoteMethod(query) {
      this.loading3 = true;
      this.getTeacherlist(query);
    },
    remoteMethodchange(query) {
      if (query == '') {
        this.loading3 = true;
        this.getTeacherlist('');
      }
    },
    getTermDate() {
      if (this.listParams.termId && this.listParams.termId != -1) {
        const key = this.termIdList.findIndex(item => { return item.termId === this.listParams.termId; });
        return [this.termIdList[key]['beginDate'], this.termIdList[key]['endDate']];
      }
      return [];
    }
  }
};
</script>
